import { render, staticRenderFns } from "./SafePassword.vue?vue&type=template&id=68621208&scoped=true&"
import script from "./SafePassword.vue?vue&type=script&lang=js&"
export * from "./SafePassword.vue?vue&type=script&lang=js&"
import style0 from "./SafePassword.vue?vue&type=style&index=0&id=68621208&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "68621208",
  null
  
)

export default component.exports